import { CheckCircleFilled, ClockCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import styles from '../treasury/elements/styles/pills.module.scss';
import { SUPPORT_TICKET_STATUS } from './support.enums';

// Pure enums live in `support.enums.js` (no SCSS/JSX). Re-export here so
// existing `import { … } from './support.constants'` keeps working.
export { SUPPORT_TICKET_STATUS, SupportTicketConstants } from './support.enums';

export const supportStatusIcons = {
    [SUPPORT_TICKET_STATUS.OPEN]: <CheckCircleFilled />,
    [SUPPORT_TICKET_STATUS.PENDING]: <ClockCircleFilled />,
    [SUPPORT_TICKET_STATUS.AWAITING_CUSTOMER]: <ClockCircleFilled />,
    [SUPPORT_TICKET_STATUS.RESOLVED]: <CheckCircleFilled />,
    [SUPPORT_TICKET_STATUS.CLOSED]: <CloseCircleFilled />,
};

export const supportStatusLabels = {
    [SUPPORT_TICKET_STATUS.OPEN]: 'Open',
    [SUPPORT_TICKET_STATUS.PENDING]: 'Pending',
    [SUPPORT_TICKET_STATUS.AWAITING_CUSTOMER]: 'Awaiting customer',
    [SUPPORT_TICKET_STATUS.RESOLVED]: 'Resolved',
    [SUPPORT_TICKET_STATUS.CLOSED]: 'Closed',
};

export const supportStatusTones = {
    [SUPPORT_TICKET_STATUS.OPEN]: styles.statusSuccess,
    [SUPPORT_TICKET_STATUS.PENDING]: styles.statusWarning,
    [SUPPORT_TICKET_STATUS.AWAITING_CUSTOMER]: styles.statusWarning,
    [SUPPORT_TICKET_STATUS.RESOLVED]: styles.statusSuccess,
    [SUPPORT_TICKET_STATUS.CLOSED]: styles.statusDanger,
};
